import {useState} from 'react'
import axios from 'axios'

const Register = () => {

    const [Username, setUser] = useState('');
    const [password, setPassword] = useState('');

    const submithandler = (e) => {
        e.preventDefault()
        axios.post("https://api.kgphotographies.com/api/register",{
          Username,
          password
        },{withCredentials: true})
        .then((res)=>{
          console.log(res.data.user);
        }).catch((err)=>{
          console.log(err.response.data)
        });
      };

      return(
        <div className='backgroundimg'>
        
        <form onSubmit={submithandler} autoComplete="off">
            <div>
                <h1 className=''>Login</h1>
            </div>
            <div className="form-label">
                    <label className=''><h3>Username:</h3> 
                    <input className="form-control border border-dark"
                    onChange={(e) =>setUser(e.target.value)}
                    name="Username"
                    type="text"
                    />
                    </label>
                </div>
    
              <div className="form-label">
                  <label className='form-label'>
                    <h3>Password:</h3>
                    <input
                      className="form-control border border-dark"
                      onChange={(e) => setPassword(e.target.value)}
                      name="password"
                      type="password"  // Change type to "password"
                      autoComplete="current-password"  // Add autocomplete attribute
                    />
                  </label>
                </div>

                <button className='btn custom-btn mt-3 p2'>Login</button>
            
            </form>
            
            </div>
    
    
        );
}

export default Register